"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class InvoiceRequest extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'invoiceRequest';
        this._assetIds = (0, util_1.camelArray)(initParams.asset_ids);
        this._vat = initParams.vat;
        this._memo = initParams.memo;
        this._dueDate = initParams.due_date;
        this._pdfPer = initParams.pdf_per;
        this._startDate = initParams.start_date;
        this._endDate = initParams.end_date;
        this._status = initParams.status;
        this._size = initParams.size;
        this._customerEmail = initParams.customer_email;
        this._customerName = initParams.customer_name;
        this._includeBranding = initParams.include_branding;
        this._invoiceNo = initParams.invoice_no;
        this._vatId = initParams.vat_id;
        this._issuingOrgEmail = initParams.issuing_org_email;
        this._issuingOrgName = initParams.issuing_org_name;
        this._issuingOrgPhoneNumber = initParams.issuing_org_phone_number;
    }
    set assetIds(value) {
        console.error('Do not set objects this way');
    }
    get assetIds() {
        return this._assetIds;
    }
    set vat(value) {
        console.error('Do not set objects this way');
    }
    get vat() {
        return this._vat;
    }
    set memo(value) {
        console.error('Do not set objects this way');
    }
    get memo() {
        return this._memo;
    }
    set dueDate(value) {
        console.error('Do not set objects this way');
    }
    get dueDate() {
        return this._dueDate;
    }
    set pdfPer(value) {
        console.error('Do not set objects this way');
    }
    get pdfPer() {
        return this._pdfPer;
    }
    set startDate(value) {
        console.error('Do not set objects this way');
    }
    get startDate() {
        return this._startDate;
    }
    set endDate(value) {
        console.error('Do not set objects this way');
    }
    get endDate() {
        return this._endDate;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    get status() {
        return this._status;
    }
    set size(value) {
        console.error('Do not set objects this way');
    }
    get size() {
        return this._size;
    }
    set customerEmail(value) {
        console.error('Do not set objects this way');
    }
    get customerEmail() {
        return this._customerEmail;
    }
    set customerName(value) {
        console.error('Do not set objects this way');
    }
    get customerName() {
        return this._customerName;
    }
    set includeBranding(value) {
        console.error('Do not set objects this way');
    }
    get includeBranding() {
        return this._includeBranding;
    }
    set invoiceNo(value) {
        console.error('Do not set objects this way');
    }
    get invoiceNo() {
        return this._invoiceNo;
    }
    set vatId(value) {
        console.error('Do not set objects this way');
    }
    get vatId() {
        return this._vatId;
    }
    set issuingOrgEmail(value) {
        console.error('Do not set objects this way');
    }
    get issuingOrgEmail() {
        return this._issuingOrgEmail;
    }
    set issuingOrgName(value) {
        console.error('Do not set objects this way');
    }
    get issuingOrgName() {
        return this._issuingOrgName;
    }
    set issuingOrgPhoneNumber(value) {
        console.error('Do not set objects this way');
    }
    get issuingOrgPhoneNumber() {
        return this._issuingOrgPhoneNumber;
    }
    delete() {
        return this.dataService.deleteInvoiceRequest(this.id, this);
    }
}
exports.default = InvoiceRequest;
//# sourceMappingURL=invoiceRequest.js.map